"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 54.78 24",
    width: "54.78",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m54 15.2h-3.25v-6.37l4-5.17v-2.86a.81.81 0 0 0 -.75-.8h-53.16a.8.8 0 0 0 -.84.76v2.84l4 5.23v6.37h-3.19a.78.78 0 0 0 0 1.56h3.3a3.92 3.92 0 1 0 4.05 0h3.84a3.91 3.91 0 1 0 6 3.33 4.13 4.13 0 0 0 -.08-.78.81.81 0 0 0 .75.52h17.22a.78.78 0 0 0 .65-.36 3.18 3.18 0 0 0 -.06.62 3.91 3.91 0 1 0 5.93-3.33h3.87a3.91 3.91 0 1 0 4.06 0h3.66a.78.78 0 0 0 0-1.56zm-45.51 4.89a2.35 2.35 0 1 1 -2.35-2.36 2.35 2.35 0 0 1 2.35 2.36zm5.23-10.42a.78.78 0 0 1 1.56 0v6.69a3.7 3.7 0 0 0 -1.23-.21h-.33zm.34 12.77a2.36 2.36 0 1 1 2.35-2.37 2.36 2.36 0 0 1 -2.35 2.37zm2-5.68h1.75v2.24a.75.75 0 0 0 .05.26 3.87 3.87 0 0 0 -1.78-2.5zm23.44-7.09a.78.78 0 0 1 1.56 0v6.69a3.7 3.7 0 0 0 -1.23-.21h-.33zm-2.81 9.2v-2.11h1.68a3.91 3.91 0 0 0 -1.68 2.11zm6.05 1.22a2.35 2.35 0 1 1 -2.35-2.36 2.35 2.35 0 0 1 2.35 2.36zm7.92 0a2.36 2.36 0 1 1 -2.36-2.36 2.35 2.35 0 0 1 2.35 2.35z",
    fill: "#93c01f"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m22.83 13.86v-10.96l9.12 5.48z",
    fill: "#fff"
  }));
};

exports["default"] = _default;